module.exports = __webpack_public_path__ + "9386da30fc60a0619b25ea2125bbc767.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-Marca-40px-x-40px.png
// module id = 370
// module chunks = 7